import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay, GetApp } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import AchievementInsertModal from "../AchievementInsertModal";
import AchievementExportModal from "../AchievementExportModal";

import {
  getAllAchievement,
  getAllAchievementByProfileId,
  getFilteredAchievement,
  exportAchievement,
} from "../../../reducer/achievement/action";

function AchievementButton(props) {
  const { getAllAchievement, getAllAchievementByProfileId, getFilteredAchievement } = props;

  const [inserting, setInserting] = useState(false);
  const [exporting, setExporting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllAchievementByProfileId(profileId);
    return false;
  }, []);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredAchievement.length === 0 && !props.isFetching)
      getFilteredAchievement(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredAchievement(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredAchievement]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllAchievementByProfileId(profileId);
        props.handleReload();
      }
    } else {
      getFilteredAchievement(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  const handleExport = () => setExporting(true);

  const handleExportData = async (payload) => {
    await props.exportAchievement(payload);
    setExporting(false);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Giải thưởng
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<GetApp />}
              style={{ marginLeft: 8 }}
              onClick={handleExport}
            >
              Xuất Excel
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <AchievementInsertModal inserting={inserting} setInserting={setInserting} setUpdating={props.setUpdating} />
      <AchievementExportModal exporting={exporting} setExporting={setExporting} handleExportData={handleExportData} />
    </>
  );
}

const mapStateToProps = (state) => ({
  isFetching: select(state, "achievementReducer", "isFetching"),
  isFetchingAccepted: select(state, "achievementReducer", "isFetchingAccepted"),
  listFilteredAchievement: select(state, "achievementReducer", "listFiltered"),
  profileDetail: select(state, "profileReducer", "detail"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllAchievement: () => dispatch(getAllAchievement()),
  getAllAchievementByProfileId: (id) => dispatch(getAllAchievementByProfileId(id)),
  getFilteredAchievement: (page, pageSize, payload) => dispatch(getFilteredAchievement(page, pageSize, payload)),
  exportAchievement: (payload) => dispatch(exportAchievement(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(AchievementButton));

